import { getPlatform, loadqwebchannel } from 'Api/utils/Api.utils';
import { MessageUtil, FROM_TYPE } from 'Api/utils/Message.util';
import { getQueryVariable } from 'Utils/utils';
import { collaborationApi } from 'Api/index';
export default class CollaborationApiAdapter {
  constructor() {
    const { platform, asyncCall } = getPlatform();
    this.platform = platform;
    this.asyncCall = asyncCall;
    this.fnMap = {};
    this.windowMessageUtil = null;
    this.callFunction = this.callFunction.bind(this);
    this.onRequestCallback = this.onRequestCallback.bind(this);
    this.handleOnlineFn = this.handleOnlineFn.bind(this);
    this.handlePhantomFn = this.handlePhantomFn.bind(this);
    this.handleMacFn = this.handleMacFn.bind(this);
    this.onHandleResult = this.onHandleResult.bind(this);
    this.handleWinPhantomFn = this.handleWinPhantomFn.bind(this);
    this.init = this.init.bind(this);

    this.init();
  }
  init() {
    let origin = getQueryVariable('origin');
    let isDebug = getQueryVariable('debug');
    this.isDebug = isDebug;
    if (origin) {
      this.windowMessageUtil = new MessageUtil(isDebug);
      this.windowMessageUtil.init(this.onRequestCallback, FROM_TYPE.Online_Collaboration, origin);
    }
  }
  onRequestCallback(method, data, id) {
    return new Promise((resolve) => {
      const fn = this.fnMap[method];
      fn && fn({ method, data, id, resolve });
    });
  }
  handleOnlineFn(method, data/*, onEvent*/) {
    //console.log('handleOnlineFn method:' + method, data)
    // return this.windowMessageUtil.handleMessage(method, data, onEvent);
    switch (method) {
      case 'getUserToken':
        return collaborationApi.getUserToken(data);
      case 'getCDocInfo':
        return collaborationApi.getCDocInfo(data);
      case 'getCurrentDoc':
        return collaborationApi.getCurrentDoc()
      case 'getFileStream':
        return collaborationApi.getFileStream(data)
      case 'openSharedFile':
        return collaborationApi.openSharedFile(data)
      case 'postErrorMsg':
        return collaborationApi.postErrorMsg(data)
      default:
        break
    }
  }
  getPlatform = () => {
    return this.platform;
  };

  handlePhantomFn(args, method, onEvent) {
    return new Promise((resolve) => {
      let args2 = args[2];
      typeof args2 === 'object' && (args2 = JSON.stringify(args[2]));
      let szResult = window.external.DispatchFun(args[0], args[1], args2);
      console.log('return result:', szResult);
      this.onHandleResult(szResult, method, resolve, onEvent);
    });
  }
  handleMacFn(args, method, onEvent) {
    let _this = this;
    return new Promise((resolve) => {
      let args2 = args[2];
      typeof args2 === 'object' && (args2 = JSON.stringify(args[2]));
      if (this.asyncCall) {
        if (window.external) {
          window.external.DispatchFun(args[0], args[1], args2, function (result) {
            _this.onHandleResult(result, method, resolve, onEvent);
            //resolve(result);
          });
        } else {
          loadqwebchannel(() => {
            window.external.DispatchFun(args[0], args[1], args2, function (result) {
              !!this.isDebug && console.log('loadqwebchannel finish init');
              _this.onHandleResult(result, method, resolve, onEvent);
            });
          });
        }
      } else {
        let result = window.external.DispatchFun(args[0], args[1], args2);
        _this.onHandleResult(result, method, resolve, onEvent);
      }
    });
  }
  onHandleResult(szResult, method, resolve, onEvent) {
    !!this.isDebug && method !== 'getFileStream' && console.log('DispatchFun return result:', szResult);
    let handle = setTimeout(() => {
      clearTimeout(handle);
      if (!szResult) {
        console.error('callFunction method:' + method + '\nDispatchFun return Null: ');
        resolve({ ret: 999 });
        return;
      }
      let result;
      try {
        result = JSON.parse(szResult);
        console.log(result);
      } catch (error) {
        console.error('callFunction method:' + method + '\nDispatchFun return Wrong data format: ' + '\n' + szResult);
        resolve({ ret: 999 });
        return;
      }
      if (onEvent) {
        onEvent(result);
        return;
      }
      resolve(result);
    }, 0);
  }
  handleWinPhantomFn(args, method, onEvent) {
    return new Promise((resolve) => {
      let args2 = args[2];

      typeof args2 === 'object' && (args2 = JSON.stringify(args[2]));
      console.log('chrome cor args', `DispatchFun:${args[0]};${args[1]}(${args2})`);
      window.cefQuery({
        request: `DispatchFun:${args[0]};${args[1]}(${args2})`,
        onSuccess: (response) => {
          console.log('return result:', response);
          this.onHandleResult(response, method, resolve, onEvent);
        },
        onFailure: (errorCode, errorMessage) => {
          console.log('return error result:', error_code, error_message);
          reject(`${errorCode}: ${errorMessage}`)
        },
      });
    });
  }
  callFunction(module, method, data, onEvent) {
    //let args = Array.prototype.slice.call(arguments, 0);
    let args = [module, method, data];
    const {platform} = getPlatform()
    // let _this = this;
    !!this.isDebug && console.log('callFunction begin: method ' + method + ', data:' + JSON.stringify(data));
    //console.log(platform);
    try {
      switch (platform) {
        case 'Teams':
        case 'PhantomOnline': {
          //console.log("PluginApiAdapter -> callFunction -> args[0], args[1], args[2]", args[0], args[1], args[2])
          return this.handleOnlineFn(args[1], args[2], onEvent);
        }
        case 'FoxitReader':
        case 'Phantom': {
          return this.handlePhantomFn(args, method, onEvent);
        }
        case 'WinPhantom': {
          return this.handleWinPhantomFn(args, method, onEvent)
        }
        case 'MacReader':
        case 'MacPhantom':
        case 'Lite': {
          return this.handleMacFn(args, method, onEvent);
        }
        case 'IOS': {
          return new Promise((resolve) => {
            if (this.asyncCall) {
              let id = cuid();
              window[id] = function (resultValue) {
                resolve(resultValue);
                delete window[id];
              };
              window.webkit.messageHandlers.DispatchFun.postMessage([args[0], args[1], args[2], id]);
            } else {
              let result = window.external.DispatchFun(args[0], args[1], args[2]);
              setTimeout(() => {
                resolve(result);
              }, 0);
            }
          });
        }
        case 'Android': {
          return new Promise((resolve) => {
            let result = window.external.DispatchFun(args[0], args[1], args[2]);

            setTimeout(() => {
              resolve(result);
            }, 0);
          });
        }

        case 'platformSeven': {
          return {}
          // return new Promise((resolve) => {
          //   //let modulename = args.shift();
          //   let fname = args.shift();
          //   // if (fname == "expandPanel" || fname == "isPanelActivate") {
          //   // 	let fn = parent.fnlist[window.name][fname].bind(null, window.name);
          //   // 	return fn(args);
          //   // }
          //   // try {
          //   resolve(parent.fnlist[window.name][fname](args[0]));
          //   // } catch (e) {
          //   //  	console.error(e, fname);
          //   // }\}
          //   //
          // });
        }
        default: {
          return new Promise((resolve) => {
            resolve({ ret: 999 });
          });
          //throw 'unknow platform' + this.platform;
        }
      }
    } catch (error) {
      //console.log('callFunction try catch error')
    }
  }
}
